import React from "react";
import ProfilePicture from "../images/avatar-defaul-boy.jpg";
import Hommies from "../Components/TopHomies";
import { Link, useHistory } from "react-router-dom";
import UserContext from "../UserContext";
import { RiEditCircleFill } from "react-icons/ri";
import { url } from "../utils/url";
import ShowLikesModal from "./Modals/ShowLikesModal";
import axios from "axios";
import { BiMessageSquareDots } from "react-icons/bi";
import { BsPersonPlus, BsPersonDash } from "react-icons/bs";

export default function Profile({ currentuser, count }) {
  const {
    user,
    posts,
    users,
    mode,
    reloadRequests,
    makeHommie,
    removeHommie,
  } = React.useContext(UserContext);
  const history = useHistory();
  const [modalShow, setmodalShow] = React.useState(0);
  const [usersToShow, setusersToShow] = React.useState([]);
  const [sendingRequest, setsendingRequest] = React.useState(null);
  const [loadedposts, setloadedposts] = React.useState([]);

  let displayuser = currentuser?._id ? currentuser : user.info;
  let myPosts = posts.filter((post) => {
    return post.user_id === displayuser._id;
  });

  // setting the theme
  const [dark, setDark] = React.useState(false);
  React.useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  React.useEffect(() => {
    changeusersToShow();
    // eslint-disable-next-line
  }, [users, modalShow]);

  React.useEffect(() => {
    async function loadPosts() {
      if (!count) {
        await axios
          .get(`${url}/api/posts/getposts/user/${displayuser?._id}`)
          .then((res) => {
            setloadedposts(res.data.data || []);
          });
      }
    }
    loadPosts();
  }, [displayuser, count]);

  const changeusersToShow = () => {
    const tempusers = (modalShow === 1
      ? displayuser.hommies
      : modalShow === 2
      ? displayuser.followings
      : []
    )?.map((user) => {
      return users?.find((record) => record._id === user);
    });
    setusersToShow(tempusers);
  };

  const clickHommy = async (id) => {
    if (!user.token) {
      window.Toast.fire({
        icon: "error",
        title: "You are not authorized to this service",
      });
      return;
    }
    setsendingRequest(id);
    let response = await makeHommie(id);
    if (response.success && response.message) {
      window.Toast.fire({ icon: "success", title: response.message });
    }
    reloadRequests();
    setsendingRequest(null);
  };

  const clickRemoveHommy = async (id) => {
    setsendingRequest(id);
    let response = await removeHommie(id);
    if (response.success && response.message) {
      window.Toast.fire({ icon: "success", title: response.message });
    }
    reloadRequests();
    setsendingRequest(null);
  };

  let me = displayuser?._id === user?.info?._id;
  let img_url = displayuser?.image
    ? displayuser?.image
    : url + displayuser.profile?.url || ProfilePicture;
  return (
    <div
      className={
        dark
          ? "container loggedin-container darkmode divbg-in-darkmode"
          : "container  loggedin-container"
      }
    >
      <div className="flex justify-between items-center pb-2">
        <div className="flex justify-start items-center">
         <div className="bg-gray-100 rounded-full w-16 h-16 flex items-center justify-center">
         <img
            src={img_url}
            alt={`${displayuser.username}'s profile'`}
            className="cursor-pointer object-cover w-16 h-16 rounded-full"
            onClick={() => {
              history.push(`/users/${displayuser?.username}`);
            }}
          />
         </div>
          <div
            className="c-pointer ml-3"
            onClick={() => {
              history.push(`/users/${displayuser?.username}`);
            }}
          >
            <h6 className="flex gap-3">
              {displayuser?.names}

              {displayuser?.account_type === "VERIFIED" && (
                <div title="Account verified">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                      d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414L11.003 16z"
                      fill="rgba(249,2,2,1)"
                    />
                  </svg>
                </div>
              )}
            </h6>
            <span>
              {displayuser.userStatus || "Twika User" || displayuser.username}
            </span>
          </div>
        </div>
        <div>
          {displayuser?._id === user.info?._id && (
            <Link to="/edit-profile">
              {" "}
              <RiEditCircleFill style={{ fontSize: "20px" }} />
            </Link>
          )}
        </div>
      </div>
      <hr />
      <div className="flex justify-between items-center py-2">
        <ShowLikesModal
          title={
            modalShow === 1
              ? `${displayuser.names}'s hommies`
              : `${displayuser.names}'s hommings`
          }
          show={modalShow === 1 || modalShow === 2}
          onHide={() => {
            setmodalShow(0);
          }}
          users={usersToShow}
          user={user}
          sendingRequest={sendingRequest}
          addhommie={clickHommy}
          removehommie={clickRemoveHommy}
        ></ShowLikesModal>
        <div>
          <div
            className={`block no-underline mb-1 cursor-pointer ${
              dark ? "text-white" : "text-black"
            }`}
          >
            <span className="mr-4" onClick={() => setmodalShow(1)}>
              {displayuser.hommies?.length || "No"}{" "}
              {displayuser.hommies?.length > 1 ? "Hommies" : "Hommy"}
            </span>
            <span onClick={() => setmodalShow(2)}>
              {displayuser.followings?.length || "No"}{" "}
              {displayuser.followings?.length > 1 ? "Hommings" : "Homming"}
            </span>
          </div>
          <Link
            to={`/users/${displayuser.username}`}
            className={
              "block no-underline " + (dark ? " text-muted " : " text-dark ")
            }
          >
            {count || loadedposts.length || myPosts.length}{" "}
            {(count || loadedposts.length || myPosts.length) > 1
              ? "Twiks"
              : "Twik"}
          </Link>
        </div>
        <div>
          <Link
            to={me ? "/create-post" : `/messages?user=${displayuser._id}`}
            className=" no-underline "
          >
            <button
              className={`px-3 rounded ${
                me ? "py-2" : "py-1"
              } hover:opacity-80 no-underline`}
            >
              {me ? (
                <span className="bg-fire text-white px-3 py-2 rounded">
                  Hit a Twik
                </span>
              ) : (
                <div>
                  <BiMessageSquareDots
                    color={dark ? "var(--primaryFire)" : "#000"}
                    size={24}
                  />
                </div>
              )}
            </button>
          </Link>
          {!me && (
            <button
              className="font-mono italic rounded ml-2 px-2 py-1 hover:opacity-80 no-underline"
              disabled={sendingRequest === displayuser?._id}
              onClick={() =>
                user?.info?.followings?.includes(displayuser?._id)
                  ? clickRemoveHommy(displayuser?._id)
                  : clickHommy(displayuser?._id)
              }
            >
              {user?.info?.followings?.includes(displayuser?._id) ? (
                <div title="Remove Hommy">
                  <BsPersonDash color="#f90202" size={24} />
                </div>
              ) : (
                <div title="Add Hommy">
                  <BsPersonPlus color="#007bff" size={24} />
                </div>
              )}
            </button>
          )}
        </div>
      </div>

      <Hommies dark={dark} />
    </div>
  );
}